var _a;
import { IdBadgePosition } from "./IdBadgePosition";
export var mapBadgePositionTranslateMultiplier = (_a = {},
    _a[IdBadgePosition.Right] = [0.5, -0.5],
    _a[IdBadgePosition.ExtremeRight] = [0.9, -0.5],
    _a[IdBadgePosition.Left] = [-0.5, -0.5],
    _a[IdBadgePosition.ExtremeLeft] = [-0.9, -0.5],
    _a[IdBadgePosition.TopRight] = [0.4, -0.36],
    _a[IdBadgePosition.TopLeft] = [-0.4, -0.36],
    _a[IdBadgePosition.GridItemTopLeft] = [0.0, 0.0],
    _a[IdBadgePosition.BottomRight] = [0.4, 0.36],
    _a[IdBadgePosition.BottomLeft] = [-0.4, 0.36],
    _a[IdBadgePosition.Bottom] = [0, 0.36],
    _a[IdBadgePosition.BottomCenter] = [0.5, 0.36],
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/badge/mapBadgePositionTranslateMultiplier.ts
// module id = 2237
// module chunks = 3